import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';
import ProductStyle from '../ProductModal/ProductStyle';

const ReturnProductModal = ({ isOpen, onClose, products }) => {
  const { t } = useTranslation();

  // ✅ Define missing constants
  const tableHead = 'gray.600';
  const tablBody = 'gray.800';
  const bgTr = 'gray.100';

  console.log(products);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent mx="auto" my="auto" width="90%" maxW={900}>
        <ModalHeader>{t('Maxsulot')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ProductStyle>
            <Box overflow={'auto'} mb={'15px'}>
              <Table variant="unstyled" color="gray.500" position="relative">
                <Thead>
                  <Tr>
                    <Th
                      px="10px"
                      border="1px"
                      borderColor="gray.200"
                      color={tableHead}
                    >
                      {t('Nomi')}
                    </Th>
                    <Th
                      px="10px"
                      border="1px"
                      borderColor="gray.200"
                      color={tableHead}
                    >
                      {t('Narx')}
                    </Th>
                    <Th
                      px="10px"
                      border="1px"
                      borderColor="gray.200"
                      color={tableHead}
                    >
                      {t('Soni')}
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {products.map((value, index) => (
                    <Tr key={index} _hover={{ bg: bgTr }} className="tr">
                      <Td
                        width="100px"
                        cursor="pointer"
                        border="1px"
                        borderColor="gray.200"
                        fontSize={{ sm: '14px' }}
                        minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                        px="10px"
                        py="5px"
                        color={tablBody}
                      >
                        {get(value, 'itemName', '')}
                      </Td>
                      <Td
                        width="100px"
                        cursor="pointer"
                        border="1px"
                        borderColor="gray.200"
                        fontSize={{ sm: '14px' }}
                        minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                        px="10px"
                        py="5px"
                        color={tablBody}
                      >
                        {get(value, 'lineTotal', '')} {get(value, 'docCur', '')}
                      </Td>
                      <Td
                        width="100px"
                        cursor="pointer"
                        border="1px"
                        borderColor="gray.200"
                        fontSize={{ sm: '14px' }}
                        minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                        px="10px"
                        py="5px"
                        color={tablBody}
                      >
                        {get(value, 'quantity', '')}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          </ProductStyle>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ReturnProductModal;
